import { Card, Col, Row } from "antd";
import Calendar from "./Calendar";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import modifyId from "../../utils/modifyId";
import axiosClient from "../../api/axiosClient";
import handleApiError from "../../utils/handleError";
import prepareSlots from "../../utils/prepareSlots";

export interface ISlot {
  time: number;
  count: number;
}

export default function BookExamSlot() {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const [slots, setSlots] = useState<ISlot[]>([]);
  const [datesAndSlots, setDatesAndSlots] = useState<any>({});

  const voucher_id = params.id;
  const scheduleDate = location.state?.scheduleDate;

  async function handleSelect(selectedDate: any) {
    if (slots?.length) {
      navigate(`/schedule-session/available-slots/${params.id}`, {
        state: {
          slots: slots,
          selectedDate: selectedDate,
          scheduleDate,
          voucherDetails,
        },
      });
    }
  }

  const [voucherDetails, setVoucherDetails] = useState<any>({});

  useEffect(() => {
    async function getVoucherDetails() {
      try {
        let res = await axiosClient.get(`vouchers/${voucher_id}/slots`);
        setSlots(res.data);
        res = await axiosClient.get(`vouchers/${voucher_id}/details`);
        setVoucherDetails(res.data);
      } catch (error: any) {
        handleApiError(error);
      }
    }
    getVoucherDetails();
  }, [voucher_id]);

  useEffect(() => {
    setDatesAndSlots(prepareSlots(slots));
  }, [slots, setDatesAndSlots]);

  return (
    <div className="book_slot_container">
      <h5>Book Your Exam Slot</h5>
      <Card bordered={false}>
        <h5>
          1. Choose a Slot: Select a time that suits your schedule from the
          available options.
        </h5>
        <h5>
          2. Verify Slot: Double-check the chosen time to ensure it's correct
          before finalizing your booking.
        </h5>
      </Card>

      <Row
        style={{ marginTop: 30 }}
        justify="center"
        align="middle"
        gutter={[20, 20]}
      >
        <Col span={8} md={24} xl={8} lg={16}>
          <Calendar
            handleSelect={handleSelect}
            datesWithSlots={datesAndSlots}
            scheduleDate={scheduleDate}
          />
        </Col>
        <Col>
          <Row justify={"center"} gutter={[20, 20]} style={{ marginTop: 30 }}>
            <Col span={24}>
              <Row justify={"center"} gutter={[20, 20]}>
                <Col span={12}>
                  <div className="book_slot_guid_container">
                    <div className="book_slot_guide guide-available"></div>
                    <span>Available Dates</span>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="book_slot_guid_container">
                    <div className="book_slot_guide guide-today"></div>
                    <span>Today's Date</span>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify={"center"} gutter={[20, 20]}>
                <Col span={12}>
                  <div className="book_slot_guid_container">
                    <div className="book_slot_guide guide-schedule"></div>
                    <span>Scheduled Date</span>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="book_slot_guid_container">
                    <div className="book_slot_guide guide-unavailable"></div>
                    <span>Unavailable Dates</span>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Card
            title="Exam Detail"
            style={{ marginTop: 20 }}
            bordered={false}
          >
            <table className="book_slot_exam_details">
              <tbody>
                <tr>
                  <td>Exam ID</td>
                  <td>{modifyId(voucherDetails?.exam_id)}</td>
                </tr>
                <tr>
                  <td>Exam Name</td>
                  <td>{voucherDetails?.exam_name}</td>
                </tr>
                <tr>
                  <td>Duration</td>
                  <td>{voucherDetails?.duration} minutes</td>
                </tr>
              </tbody>
            </table>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
